import React, { useLayoutEffect, useState } from 'react';
import SignIn from './signin';
import OTP from './otp';
import ChooseCompany from './choose-company';
import LocalStorage from '../../../utils/extension/localstorage';
import { Box } from '@mui/material';
import { DiologLogoMedium } from 'Components/Icons/DiologLogoMedium';

const Auth = () => {
    const [step, setStep] = useState(0);
    const [email, setEmail] = useState('');
    const [companyId, setCompanyId] = useState(null);
    const [isLoading, setIsLoading] = useState({ primaryLoading: false, secondaryLoading: true });

    const setActiveStep = (value) => setStep(value);

    useLayoutEffect(() => {
        const token = LocalStorage.getAuthToken();
        if (token) {
            setActiveStep(2);
        }
    }, []);

    const loading = (value) => {
        setIsLoading({ ...isLoading, ...value });
    };

    return (
        <main className={(isLoading.primaryLoading || (step === 2 && isLoading.secondaryLoading)) && 'ext-loading'}>
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100vh" width="100vw">
                <Box className="ext-container">
                    <Box display="flex" alignItems="flex-start" justifyContent="center" mb={3}>
                        <DiologLogoMedium />
                    </Box>
                    {step === 0 && (
                        <SignIn setActiveStep={setActiveStep} setEmail={setEmail} setCompanyId={setCompanyId} loading={loading} />
                    )}
                    {step === 1 && <OTP setActiveStep={setActiveStep} email={email} setCompanyId={setCompanyId} />}
                    {step === 2 && <ChooseCompany email={email} companyId={''} isLoading={isLoading.secondaryLoading} loading={loading} />}
                </Box>
            </Box>
        </main>
    );
};

export default Auth;
